// *******************************************************************************
// Counter
// *******************************************************************************

const counterElem = document.querySelectorAll('[data-counter]');

const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting && !entry.target.classList.contains('is-done')) {
      entry.target.classList.add('is-done');
      new countUp.CountUp(entry.target, entry.target.dataset.counter).start();
    }
  }
});

counterElem.forEach((el) => observer.observe(el));
